<!-- 推广账户管理 -->
<template>
<div id="put-account">
	<a-tabs :activeKey="tab_key" type="card" @change="callback" :tabBarGutter="10">
	    <a-tab-pane v-for="(item,index) in showTabData" :key="item.keys" :tab="item.name"></a-tab-pane>
	    <!-- <a-tab-pane key="2" tab="OPPO"></a-tab-pane>
	    <a-tab-pane key="3" tab="VIVO"></a-tab-pane>
		<a-tab-pane key="4" tab="腾讯"></a-tab-pane>
		<a-tab-pane key="5" tab="百度"></a-tab-pane> -->
	</a-tabs>
	<div style="padding: 0 15px 15px;">
		<router-view/>
	</div>
</div>
</template>

<script>
import { putGzhList, } from '@/request/api'
export default {
	name: 'putAccount_',
	components: {
		
	},
	data() {
		return {
			tab_key: "1",
			tabData: [
				{name:"头条巨量引擎", keys: "1", urls:"/accountTT", },
				{name:"OPPO", keys: "2", urls:"/accountOPPO", },
				{name:"VIVO", keys: "3", urls:"/accountVIVO", },
				{name:"腾讯", keys: "4", urls:"/accountTX", },
				{name:"百度", keys: "5", urls:"/accountBD", },
				{name:"华为", keys: "6", urls:"/accountHW", },
				{name:"快手", keys: "7", urls:"/accountKS", },
				{name:"微博", keys: "8", urls:"/accountWB", },
			],
			showTabData: [{name:"",}],
		}
	},
	mounted() {
		let that = this
		
		// console.log("路由地址",this.$route.fullPath);
		let page_path = this.$route.fullPath
		let tab_path = []
		
		// console.log("get_navData",JSON.parse(localStorage.getItem("get_navData")));
		let n_data = JSON.parse(localStorage.getItem("get_navData"))
		// 找出当前路径所在的vues数据。
		n_data.forEach((res,index)=>{
			if(res.child.length != 0){
				res.child.forEach((res_a,index_a)=>{
					if(res_a.child.length != 0){
						res_a.child.forEach((res_c,index_c)=>{
							
							res_c.vues.forEach((res_e,index_e)=>{
								if(res_e.vue_url == page_path){
									tab_path = res_c.vues
								}
							})
							
						})
					}
				})
				
			}
		})
		// console.log("tab_path",tab_path);
		let tt_data = []
		// 根据后端配置的顺序进行排序
		tab_path.forEach((res,index)=>{
			that.tabData.forEach((res_z,index_z)=>{
				if(res.vue_url == res_z.urls){
					tt_data.push(res_z)
				}
			})
		})
		// console.log("tt_data",tt_data);
		that.showTabData = tt_data
		
		function checkTab(urls){
			for (let i = 0; i < that.tabData.length; i++) {
				let res = that.tabData[i]
				if(res.urls.indexOf(urls) > -1){
					that.tab_key = res.keys
					return
				}
			}
			// if(urls.indexOf("accountTT") > -1){
			// 	that.tab_key = "1"
			// }
			// else if(urls.indexOf("accountOPPO") > -1){
			// 	that.tab_key = "2"
			// }
			// else if(urls.indexOf("accountVIVO") > -1){
			// 	that.tab_key = "3"
			// }
			// else if(urls.indexOf("accountTX") > -1){
			// 	that.tab_key = "4"
			// }
			// else if(urls.indexOf("accountBD") > -1){
			// 	that.tab_key = "5"
			// }
			// else if(urls.indexOf("accountHW") > -1){
			// 	that.tab_key = "6"
			// }
			// else if(urls.indexOf("accountKS") > -1){
			// 	that.tab_key = "7"
			// }
		}
		// 保证页面刷新能更新tab选中状态
		checkTab(that.$route.fullPath)
		
		// 接收子页面传过来的路径
		this.$bus.$on('tabPath',(e)=>{
		    console.log('putAccount-tabPath-----',e)
			// that.table_scroll_width = e
			checkTab(e)
		})
	},
	// 销毁生命周期
	beforeDestroy(){
		// 如果不销毁，后面可能会重复执行多次，因为没有销毁，所以触发的会一直在
		this.$bus.$off('tabPath') // 销毁，减轻vue压力
	},
	methods:{
		// 切换tab
		callback(e){
			let that = this
			console.log(e);
			for (let i = 0; i < that.tabData.length; i++) {
				let res = that.tabData[i]
				if(res.keys == e){
					that.tab_key = res.keys
					that.$router.push({path: res.urls})
					return
				}
			}
			// if(e == "1"){ // 头条巨量引擎
			// 	this.tab_key = e
			// 	this.$router.push({path: '/accountTT'})
			// }
			// else if(e == "2"){ // OPPO
			// 	this.tab_key = e
			// 	this.$router.push({path: '/accountOPPO'})
			// }
			// else if(e == "3"){ // VIVO
			// 	this.tab_key = e
			// 	this.$router.push({path: '/accountVIVO'})
			// }
			// else if(e == "4"){ // 腾讯
			// 	this.tab_key = e
			// 	this.$router.push({path: '/accountTX'})
			// }
			// else if(e == "5"){ // 百度
			// 	this.tab_key = e
			// 	this.$router.push({path: '/accountBD'})
			// }
			// else if(e == "6"){ // 华为
			// 	this.tab_key = e
			// 	this.$router.push({path: '/accountHW'})
			// }
			// else if(e == "7"){ // 快手
			// 	this.tab_key = e
			// 	this.$router.push({path: '/accountKS'})
			// }
		}
	},
}	
</script>

<style>
/* 用于子页面的样式 */
.title-tab-box {
	color: #313a46;
	padding: 8px 20px;
	border: 1px solid #ccc;
	cursor: pointer;
}

.title-tab-box-selected {
	color: #62a8ea;
	border: 1px solid #62a8ea;
}


</style>